export default __webpack_public_path__ + "static/media/auth-illustration-abstract-bottom.d57b8fa3.png";